import { FETCH_CHANNELS, FETCH_CHANNELS_DONE, FETCH_CHANNELS_ERROR, FETCH_CHANNELS_SUCCESS } from 'api/Channels/constants'
import type { Ranges } from 'api/System/types'
import { getDateKey } from 'data/utils'
import { moment } from 'locale'
import type { Action } from 'redux'
import type { RequestDate } from 'types/UI'
import { emptyObject, parseDateForRequest } from 'utils'

import type { Channel, Channels } from './types'

interface ReducerAction extends Action {
  payload: {
    countryId: string
    data: Channel[]
    dateCompared?: RequestDate | null
    dateCurrent: RequestDate
    errorCode?: number
    range: Ranges
  }
}

export default function channels(state: Channels = emptyObject, { payload, type }: ReducerAction) {
  switch (type) {
    case FETCH_CHANNELS:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          errorCode: null,
          isLoading: true,
        },
      }
    case FETCH_CHANNELS_DONE:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          isLoading: false,
        },
      }
    case FETCH_CHANNELS_ERROR:
      return {
        ...state,
        [getDateKey(payload)]: {
          errorCode: payload?.errorCode,
          isLoading: false,
        },
      }
    case FETCH_CHANNELS_SUCCESS:
      return {
        ...state,
        [getDateKey(payload)]: {
          data: payload.data,
          fetchTime: parseDateForRequest(moment(), true),
          isLoading: false,
        },
      }
    default:
      return state
  }
}
